<template>
  <div class="container-fluid">
    <div class="card search-card">
      <div class="card-body">
        <div class="form-row">
          <div class="col-sm-3 col-md-2">
            <div class="form-group">
              <label for="search-workplace-name">工作地點</label>
              <input
                type="text"
                id="search-workplace-name"
                class="form-control"
                placeholder="請輸入關鍵字"
                v-model.trim="search.keyword"
                @keyup.enter="getWorkplace"
              />
            </div>
          </div>
          <div class="col-sm-3 col-md-4">
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              @click="getWorkplace"
            >
              {{ i18n("Buttons.Search") }}
            </button>
            <button
              type="button"
              class="btn btn-primary"
              style="margin-top: 30px; margin-left: 10px"
              data-toggle="modal"
              data-target="#workplaceModal"
              @click="workplaceModal({ action: 'add' })"
            >
              {{ i18n("Buttons.Add") }}
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="yahome-table-wrap">
      <VueBootstrap4Table
        :rows="rows"
        :columns="columns"
        :config="config"
        :total-rows="totalData"
        @on-change-query="changePage"
      >
        <template slot="Edit" slot-scope="props">
          <button
            type="button"
            class="btn btn-info btn-sm"
            data-toggle="modal"
            data-target="#workplaceModal"
            @click="workplaceModal({ action: 'edit', data: props.row })"
          >
            {{ i18n("Buttons.Edit") }}
          </button>
        </template>
        <template slot="Delete" slot-scope="props">
          <button
            type="button"
            class="btn btn-danger btn-sm"
            data-toggle="modal"
            data-target="#delWorkPlaceModal"
            @click="workplace = { ...props.row }"
          >
            {{ i18n("Buttons.Delete") }}
          </button>
        </template>
        <template slot="empty-results"> 暫無資料 </template>
      </VueBootstrap4Table>
    </div>

    <!-- 新增、編輯 Modal -->
    <div
      id="workplaceModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <ValidationObserver
          ref="workplace"
          class="modal-content"
          v-slot="{ handleSubmit, reset }"
        >
          <form @reset.prevent="reset">
            <div class="modal-header">
              <span v-if="action === 'add'">新增工作地點</span>
              <span v-else>編輯工作地點</span>
            </div>
            <div class="modal-body">
              <div class="form-group">
                <ValidationProvider
                  name="工作地點"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label for="modal-workplace-name">
                    <span class="mark">*</span>
                    工作地點
                  </label>
                  <input
                    type="text"
                    id="modal-workplace-name"
                    class="form-control"
                    maxlength="50"
                    @compositionstart="is_composing = true"
                    @compositionend="is_composing = false"
                    v-model.trim="workplace.WorkPlaceName"
                  />
                  <span v-if="errors[0] && !is_composing" class="text-danger">
                    {{ errors[0] }}
                  </span>
                </ValidationProvider>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary"
                data-dismiss="modal"
              >
                {{ i18n("Buttons.Cancel") }}
              </button>
              <button
                type="button"
                class="btn btn-success"
                @click="handleSubmit(saveWorkplace)"
              >
                {{ i18n("Buttons.Save") }}
              </button>
            </div>
          </form>
        </ValidationObserver>
      </div>
    </div>

    <!-- 刪除 Modal -->
    <div
      id="delWorkPlaceModal"
      class="modal fade"
      tabindex="-1"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">刪除工作地點</div>
          <div class="modal-body">
            確認刪除
            <span style="font-weight: bolder; color: red">
              {{ workplace.WorkPlaceName }}
            </span>
            ?
          </div>
          <div class="modal-footer">
            <button type="reset" class="btn btn-secondary" data-dismiss="modal">
              {{ i18n("Buttons.Cancel") }}
            </button>
            <button
              type="button"
              class="btn btn-danger"
              data-dismiss="modal"
              @click="delWorkplace"
            >
              {{ i18n("Buttons.Delete") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* global $ */
import { mapActions } from "vuex";
import { config } from "@/components/back/table_config.js";

export default {
  name: "WorkPlaceMaintenance",

  data() {
    return {
      // compositionstart& compositionend
      is_composing: false,

      // 判斷新增、編輯
      action: "add",

      workplace: {},

      search: {},
      
      rows: [],
      totalData: 0,

      // 分頁資訊
      tableInfo: {
        page: 1,
        per_page: 10,
      },

      columns: [
        {
          label: "工作地點",
          name: "WorkPlaceName",
        },
        {
          label: "",
          name: "Edit",
          slot_name: "Edit",
        },
        {
          label: "",
          name: "Delete",
          slot_name: "Delete",
        },
      ],

      config: {
        ...config,
        server_mode: true,
      },
    };
  },

  methods: {
    // 換頁
    changePage(queryParams) {
      this.tableInfo = queryParams;
      this.getWorkplace();
    },

    // 取得 工作地點
    getWorkplace() {
      this.updateLoading(true);
      this.$api.workplace
        .getWorkplacePaging({
          ...this.search,
          isPaging: true,
          page: this.tableInfo.page,
          perPage: this.tableInfo.per_page,
        })
        .then((response) => {
          if (response.status === 200) {
            this.rows = response.data.Datas;
            this.totalData = response.data.Quantity;
          }
          this.updateLoading(false);
        });
    },

    // 工作地點 Modal
    workplaceModal({ action, data }) {
      switch (action) {
        case "add":
          this.workplace = {};
          this.action = "add";
          break;
        case "edit":
          this.workplace = { ...data };
          this.action = "edit";
          break;
      }
      this.$refs.workplace.reset();
    },

    // 新增、編輯 工作地點
    saveWorkplace() {
      $("#workplaceModal").modal("hide");
      let message;
      this.updateLoading(true);
      switch (this.action) {
        case "add":
          message = "新增成功";
          this.$api.workplace
            .postWorkplace({
              ...this.workplace,
              CreateUser: this.$cookies.get("userName"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getWorkplace();
              }
              this.updateLoading(false);
            });
          break;
        case "edit":
          message = "編輯成功";
          this.$api.workplace
            .putWorkplace({
              ...this.workplace,
              UpdateUser: this.$cookies.get("userName"),
            })
            .then((response) => {
              if (response.status === 200) {
                this.$notify({
                  title: "成功",
                  message: message,
                  type: "success",
                  duration: 2000,
                });
                this.getWorkplace();
              }
              this.updateLoading(false);
            });
          break;
      }
    },

    // 刪除 工作地點
    delWorkplace() {
      this.updateLoading(true);
      this.$api.workplace
        .deleteWorkplace(this.workplace.Guid)
        .then((response) => {
          if (response.status === 200) {
            this.$notify({
              title: "成功",
              message: "刪除成功",
              type: "success",
              duration: 2000,
            });
            this.getWorkplace();
          }
          this.updateLoading(false);
        });
    },

    // loading
    ...mapActions(['updateLoading']),

    // 多國語系
    i18n(keyStr) {
      return this.$t(keyStr);
    }
  },

  destroyed() {
    $(".modal").modal("hide");
    $("body").removeClass("modal-open");
    $(".modal-backdrop").remove();
  },
};
</script>
